<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col w-full md:w-2/3 lg:w-2/4 xl:w-2/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="w-full no-gutter justify-center items-center">

            <div class="vx-col sm:w-full md:w-full lg:w-full d-theme-dark-bg">
              <div class="p-8 login-tabs-container">

                <transition name="fade">
                  <vs-button
                    v-show="step !== 'GET_PHONE_NUMBER'"
                    @click="goToFirstStep"
                    class="back-button mt-3"
                    :icon="$vs.rtl ? 'icon-chevron-left' : 'icon-chevron-right'"
                    icon-pack="feather"
                    color="primary"
                    type="flat"
                    radius/>
                </transition>

                <!--                <I18n :hide-name="false" class="change-language-dialog"/>-->

                <div class="vx-card__title flex flex-wrap justify-center mb-5">
                  <img class="d-inline-flex w-1/3"
                       :src="`${'./logo.png'}`"
                       alt="Useral HRM"
                       loading="lazy"
                       style="width: 100px !important;height: 100px!important;object-fit: contain;">
                </div>

                <div class="vx-card__title login-box-details mb-4">
                  <h4 class="mb-4">{{ $t('login.loginToPanel', {name: 'Useral'}) }}</h4>
                  <p v-if="step === 'GET_PHONE_NUMBER'">
                    {{ $t('login.getPhoneNumberStepMessage1') }} <span
                    class="useral-text-bold">{{ $t('login.getPhoneNumberStepMessage2') }}</span>
                    {{ $t('login.getPhoneNumberStepMessage3') }}
                  </p>
                  <p v-else-if="step === 'OTP_CODE_SENT'">
                    {{ $t('login.otpCodeSentStepMessage1') }}
                    <span class="useral-text-bold phone-number" :class="$vs.rtl ? 'rtl' : 'ltr'">{{ otpResponse.sendTo }}</span>
                    {{ $t('login.otpCodeSentStepMessage2') }}
                  </p>
                  <p v-else-if="step === 'GET_SUER_ADMIN_TOKEN'">{{ $t('login.getSuperAdminTokenStepMessage') }}</p>
                </div>

                <div class="mt-8">
                  <transition name="fade">
                    <custom-email-input v-if="step === 'GET_PHONE_NUMBER'"
                                        v-model="email"
                                        :label="$t('login.email')"
                                        auto-focus
                                        :invalid-text="email.error"
                                        @pressEnter="sendData"
                    />
                  </transition>

                  <transition name="fade">
                    <custom-otp-input v-if="step === 'OTP_CODE_SENT'"
                                      ref="otpInput"
                                      input-classes="otp-input"
                                      separator="-"
                                      :num-inputs="5"
                                      inputType="number"
                                      :should-auto-focus="true"
                                      :is-input-num="true"
                                      @on-change="handleOnChange"
                                      @on-complete="handleOnComplete"/>
                  </transition>

                  <transition name="fade">
                    <vs-input
                      type="text"
                      name="superAdminToken"
                      icon-no-border
                      icon="icon icon-lock"
                      icon-pack="feather"
                      :label-placeholder="$t('login.token')"
                      :danger="!superAdminToken.isValid"
                      :danger-text="superAdminToken.error"
                      @keydown.enter="sendData"
                      v-model="superAdminToken.value"
                      v-if="step === 'GET_SUER_ADMIN_TOKEN'"
                      autofocus
                      class="w-full mt-6"/>
                  </transition>

                  <vs-row class="my-5"
                          vs-type="flex"
                          vs-justify="space-around"
                          v-if="step === 'OTP_CODE_SENT'">

                    <transition name="fade">
                      <vs-button color="dark"
                                 type="flat"
                                 v-show="!resend.status"
                                 :disabled="!resend.status">
                        <vs-col>
                          {{ $t('login.retrieveTheCode') }}
                        </vs-col>

                        <vs-col>
                          <timer-counter :init-timer="otpResponse.timer" :reset="resend.reset" @timeChange="timerNumber = $event" v-model="resend.status"/>
                        </vs-col>

                      </vs-button>
                    </transition>

                    <transition name="fade">
                      <vs-col v-if="resend.status || (parseInt(timerNumber) < 60 && otpResponse.type === 'mail')">

                        <vs-row class="my-2 text-center">
                          <vs-divider color="dark">{{ $t('login.resendOTPMessage') }}</vs-divider>
                        </vs-row>

                        <vs-row class="my-2" vs-type="flex" vs-justify="center">

                          <vs-button @click="resend.status ? resendOtpCode(false) : sendOTPCode()"
                                     icon="icon icon-message-square"
                                     icon-pack="feather"
                                     class="mx-2"
                                     color="primary"
                                     type="border">
                            {{ resend.status ? $t('login.resendOTPTypes.resend') : $t('login.resendOTPTypes.sms') }}
                          </vs-button>
                        </vs-row>
                      </vs-col>
                    </transition>
                  </vs-row>

                  <div class="flex flex-wrap justify-center my-5">
                    <vs-button @click="sendData"
                               :disabled="!email.isValid || !email.value.length"
                               v-if="step === 'GET_PHONE_NUMBER' || step === 'GET_SUER_ADMIN_TOKEN'"
                               v-text="step === 'GET_PHONE_NUMBER' ? $t('login.buttons.getOTPCode') : $t('login.buttons.login')"></vs-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-prototype-builtins */
import {resendOTPCode, sendOTPCode} from '@/http/requests/auth'
import {mapGetters} from 'vuex'
import TimerCounter from '@/components/Timer/Timer'
import CustomEmailInput from '../components/input/customEmailInput.vue'

export default {
  data () {
    return {
      timerNumber: 120,
      resend: {
        status: false,
        reset: false
      },
      otpResponse: {
        sendTo: '',
        timer: '',
        type: ''
      },
      step: 'GET_PHONE_NUMBER',
      email: {
        isValid: true,
        error: '',
        value: ''
      },
      resetOTP: false,
      otpCode: {
        isValid: true,
        error: '',
        value: ''
      },
      superAdminToken: {
        isValid: true,
        error: '',
        value: ''
      },
      checkbox_remember_me: false,
      permissions: [
        'insertUser.general',
        'insertUser.address',
        // 'insertUser.roles',
        // 'insertUser.financial',
        'insertUser.group'
      ]
    }
  },
  components: {
    CustomEmailInput,
    CustomOtpInput: () => import('../components/OTPInput/customOtpInput'),
    TimerCounter
  },
  computed: {
    ...mapGetters({
      clubInfo: 'setting/getClubInfo'
    })
  },
  methods: {
    goToFirstStep () {
      this.step = 'GET_PHONE_NUMBER'
      this.email.value = ''
      this.otpCode.value = ''
      this.superAdminToken.value = ''
    },
    otpCodeValidator () {
      // convert persian digit to english digit
      this.otpCode.isValid = this.$u.convertPersianNumberToEnglish(this.otpCode.isValid)

      this.otpCode.isValid = this.$u.validator('regex.OTPCode').test(this.otpCode.value)
      if (!this.otpCode.isValid) {
        this.otpCode.error = this.otpCode.value ? this.$t('login.otpCodeIsNotValid') : this.$t('login.otpCodeIsNull')
      }
    },
    sendData () {

      switch (this.step) {
      case 'GET_PHONE_NUMBER':
        this.sendOTPCode()
        break

      case 'OTP_CODE_SENT':
        this.login()
        break

      case 'GET_SUER_ADMIN_TOKEN':
        this.loginAdmin()
        break
      }
    },
    sendOTPCode () {
      if (this.email.isValid) {

        // send otp code to valid phone number
        sendOTPCode(this.email.value).then(response => {

          // check user is super admin or not
          if (response.data.message === 'super_admin') {
            this.step = 'GET_SUER_ADMIN_TOKEN'
          } else {
            const info = response.data
            this.otpResponse.sendTo = info.send_to
            this.otpResponse.timer = info.expire_time
            this.otpResponse.type = info.type

            // show success message
            this.$vs.notify({
              time: this.$u.getReadingTime(response.data.hasOwnProperty('message') ? this.$t('login.otpSend', {number: this.otpResponse.sendTo}) : response.data),
              title: this.$t('login.otp'),
              text: response.data.hasOwnProperty('message') ? this.$t('login.otpSend', {number: this.otpResponse.sendTo}) : response.data,
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'success'
            })

            this.step = 'OTP_CODE_SENT'

            // reset timer
            this.resend.reset = true
            setTimeout(() => {
              this.resend.reset = false
            }, 500)
          }

        }).catch(error => {
          // show error message
          switch (error.response.status) {
          case 404:
            this.$vs.notify({
              time: this.$u.getReadingTime(this.$t('login.notification.userNotFound')),
              title: this.$t('alert.error.title'),
              text: this.$t('login.notification.userNotFound'),
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
            break

          case 403:
            this.$vs.notify({
              time: this.$u.getReadingTime(this.$t('login.notification.accessError')),
              title: this.$t('alert.error.title'),
              text: this.$t('login.notification.accessError'),
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
            break

          default:
            this.$vs.notify({
              time: this.$u.getReadingTime(error.response.data.message),
              title: this.$t('alert.error.title'),
              text: error.response.data.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
            break
          }

        })
      }
    },
    resendOtpCode (voice) {
      if (this.email.isValid) {
        resendOTPCode(this.email.value, voice)
          .then(response => {

            // show success message
            if (!voice) this.$vs.notify({
              time: this.$u.getReadingTime(response.data.hasOwnProperty('message') ? this.$t('login.otpSend', {number: this.otpResponse.sendTo}) : response.data),
              title: this.$t('login.otp'),
              text: response.data.hasOwnProperty('message') ? this.$t('login.otpSend', {number: this.otpResponse.sendTo}) : response.data,
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'success'
            })
            else this.$vs.notify({
              time: this.$u.getReadingTime(this.$t('login.otpCall', {number: this.email.value})),
              title: this.$t('alert.message.title'),
              text: this.$t('login.otpCall', {number: this.email.value}),
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'success'
            })
            this.step = ''
            const info = response.data
            this.otpResponse.sendTo = info.send_to
            this.otpResponse.timer = info.expire_time
            this.otpResponse.type = info.type

            this.step = 'OTP_CODE_SENT'

            // reset timer
            this.resend.reset = true
            setTimeout(() => {
              this.resend.reset = false
            }, 500)

          }).catch(error => {
            // show error message
            switch (error.response.status) {
            case 404:
              this.$vs.notify({
                time: this.$u.getReadingTime(this.$t('login.notification.userNotFound')),
                title: this.$t('alert.error.title'),
                text: this.$t('login.notification.userNotFound'),
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
              break

            case 403:
              this.$vs.notify({
                time: this.$u.getReadingTime(this.$t('login.notification.accessError')),
                title: this.$t('alert.error.title'),
                text: this.$t('login.notification.accessError'),
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
              break

            default:
              this.$vs.notify({
                time: this.$u.getReadingTime(error.response.data.message),
                title: this.$t('alert.error.title'),
                text: error.response.data.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
              break
            }
          })
      }
    },
    handleOnComplete (value) {
      this.otpCode.value = value
      this.sendData()
    },
    handleOnChange () {
      // console.log('OTP changed: ', value)
    },
    login () {
      this.otpCodeValidator()

      if (this.email.isValid && this.otpCode.isValid) {
        const payload = {
          checkbox_remember_me: this.checkbox_remember_me,
          user: {
            email: this.email.value,
            otpCode: this.otpCode.value
            // permissions: this.permissions
          },
          notify: this.$vs.notify,
          closeAnimation: this.$vs.loading.close
        }

        this.$store.dispatch('auth/loginUser', payload).then(() => {
          setTimeout(() => {
            this.$router.push({name: 'home'})
          }, 100)
        }).catch(() => {
          /*this.otpCode.value = ''
          this.resetOTP = true

          setTimeout(() => {
            this.resetOTP = false
          }, 500)*/
          this.$refs.otpInput.clearInput()
        })
      }
    },
    loginAdmin () {
      if (this.email.isValid && this.superAdminToken.isValid) {
        const payload = {
          checkbox_remember_me: this.checkbox_remember_me,
          user: {
            email: this.email.value,
            token: this.superAdminToken.value,
            super_admin: true
            // permissions: this.permissions
          },
          notify: this.$vs.notify,
          closeAnimation: this.$vs.loading.close
        }

        this.$store.dispatch('auth/loginUser', payload).then(() => {
          setTimeout(() => {
            this.$router.push({name: 'home'})
          }, 500)
        })
      }
    }
  }
}
</script>

<style lang="scss">
#page-login {

  .back-button {
    right: 24px;
    position: absolute !important;
    border: 1px solid !important;

    i {
      font-size: 20px;
      font-weight: 600;
    }
  }

  .change-language-dialog {
    position: absolute !important;
    left: 21px;
    margin-top: 10px;
    padding: 10px;
  }

  .login-box-details {
    font-size: 12px;
    text-align: justify;

    h4 {
      font-size: 14px;
    }

    .phone-number {
      display: inline-flex;
    }
  }

  .text-right {

    input[name='phoneNumber'], input[name='superAdminToken'] {
      text-align: left !important;
      direction: ltr !important;
    }
  }

  .text-left {

    input[name='phoneNumber'], input[name='superAdminToken'] {
      text-align: right !important;
      direction: rtl !important;
    }
  }
}
</style>
